import styles from "./Shared.module.scss";
import React from "react";
import OverallNps from "../../orderDetails/nps/overall/OverallNps";
import { useAppDispatch, useAppSelector } from "utils/store";
import { NPSActions } from "core/nps/nps.slice";
import { strings } from "intl/fa";
import { CampaignState, CampaignType } from "core/orderAd/orderAd.entity";

export const CampaignStateText = {
  [CampaignState.Approved]: strings.campaign_labels.Approved,
  [CampaignState.AwaitingApproval]: strings.campaign_labels.AwaitingApproval,
  [CampaignState.Active]: strings.campaign_labels.Active,
  [CampaignState.Finished]: strings.campaign_labels.Finished,
  [CampaignState.Rejected]: strings.campaign_labels.Rejected,
  [CampaignState.Canceled]: strings.campaign_labels.Canceled,
  [CampaignState.Paused]: strings.campaign_labels.Paused,
};

export const CampaignTypeText = {
  [CampaignType.ClickBased]: strings.bonus_code_errors.clicky,
  [CampaignType.ViewBased]: strings.bonus_code_errors.viewy,
};

export function AdsListShimmer() {
  const titleShimmer = (
    <div className={styles.TitleShimmerWrapper}>
      <div className={`${styles.orderedAdsListShimmer} ${styles.TitleShimmer}`}>
        <div className={`${styles.ShimmerLine} ${styles.TitleShimmer}`}></div>
        <div className={`${styles.Shimmer} ${styles.TitleShimmer}`}></div>
      </div>
    </div>
  );
  const RowShimmer = (
    <div className={styles.orderedAdsListShimmer}>
      <div className={styles.ShimmerLine}></div>
      <div className={styles.Shimmer}></div>
    </div>
  );
  return (
    <div className={styles.ShimmersWrapper}>
      {titleShimmer}
      {RowShimmer}
      {RowShimmer}
      {RowShimmer}
      {RowShimmer}
      {RowShimmer}
    </div>
  );
}

export const OrderItemsList: React.FC<React.PropsWithChildren<unknown>> = (props) => {
  const showOverallNPS = useAppSelector((state) => state.NPS.show_overall_nps);
  const dispatch = useAppDispatch();

  return (
    <div className={styles.Wrapper}>
      <div className={styles.Container}>
        {showOverallNPS && (
          <OverallNps
            onClose={() =>
              dispatch(
                NPSActions.setNPSStatus({
                  audience_group_id: 0,
                  show_overall_nps: false,
                })
              )
            }
          />
        )}
        {props.children}
      </div>
    </div>
  );
};
